var map = {
	"./interface.class": [
		95807,
		215
	],
	"./interface.class.js": [
		95807,
		215
	],
	"./saffronAxios": [
		95010,
		218,
		215
	],
	"./saffronAxios.js": [
		95010,
		218,
		215
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 33333;
module.exports = webpackAsyncContext;